export const privacyPolicy = `
# Privacy Policy

### Introduction
We are committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.

### Information We Collect
We may collect and process the following data about you:

#### Personal Identification Information
- Name
- Email address
- Phone number
- Place of residence
- IP address on signup for signing legal notice and privacy policy

#### Event-related Information
If you subscribe for an event we will save the following information:
- Event preferences
- Workshop sessions selected

#### Nightscout Information
If you make use of our Nightscout hosting service we will save the following information:
- Nightscout URL
- Information necessary to host and mantain your Nightscout instance


### How We Use Your Information
We use the information we collect in the following ways:
- To process your payments. 
- To manage your workshop event subscription and attendance.
- To communicate with you about event updates, schedules, and important information.
- To improve our website, software and support service.
- To respond to your inquiries, support requests, and complaints.
- To give medical coaching as part of our service to optimize diabetes management. 

### Sharing Your Information
We do not sell, trade, or otherwise transfer your personal information to outside parties. 
We only have access to the information necessary to host and maintain your Nightscout instance.
When making use of our coaching service, we will look at your Nightscout data to provide the appropriate telemonitoring and medical coaching.
During the coaching process, the data will only be available to assigned coaches.


### Data Security
We use administrative, technical, and physical security measures to help protect your personal information. However, no electronic storage or transmission of data over the internet can be guaranteed to be 100% secure, so we cannot ensure or warrant the security of any information you transmit to us.

### Your Data Protection Rights
You have the following rights regarding your personal information:
- **Access:** You have the right to request copies of your personal information.
- **Rectification:** You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete.
- **Erasure:** You have the right to request that we erase your personal information.
- **Restriction of Processing:** You have the right to request that we restrict the processing of your personal information.
- **Objection to Processing:** You have the right to object to our processing of your personal information.
- **Data Portability:** You have the right to request that we transfer the data that we have collected to another organization, or directly to you.

### Third-Party Vendors
We rely on the following third-party vendors to assist us in delivering our services. These vendors are carefully selected to ensure compliance with applicable privacy laws and maintain a high standard of data protection.

#### MongoDB
We use MongoDB to securely store and manage data related to your Nightscout instance and other relevant services. MongoDB’s database solutions ensure your data is encrypted and accessible only for authorized purposes. For more information on MongoDB’s privacy practices, please visit <a href="https://www.mongodb.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">MongoDB's Privacy Policy</a>.

#### TransIP
We use TransIP for managing our Kubernetes infrastructure, which powers the deployment and orchestration of our services, including Nightscout hosting. The data storage is located in Rotterdam, the Netherlands.TransIP is NEN 7510 certified and ensures secure and reliable infrastructure solutions for running our applications. For more information, please visit <a href="https://www.transip.eu/legal-and-security/privacy-policy/#:~:text=We%20only%20use%20your%20personal,parties%20without%20well%2Dfounded%20reason" target="_blank" rel="noopener noreferrer">TransIP's Privacy Policy</a>.

#### Heroku
We use Heroku as part of our platform’s backend infrastructure for hosting and managing applications. Heroku helps us ensure scalability and reliability while maintaining secure access to your data. For more information, please visit <a href="https://devcenter.heroku.com/articles/security-privacy-compliance" target="_blank" rel="noopener noreferrer">Heroku's Privacy Policy</a>.

#### Firebase
We use Firebase for real-time database services, user authentication, and communication purposes. Firebase allows us to provide a seamless and secure user experience. For more information, please visit <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase's Privacy Policy</a>.

#### Stripe
We use Stripe for processing payments. Stripe ensures secure and reliable payment processing solutions. For more information, please visit <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe's Privacy Policy</a>.

#### Google Analytics
We use Google Analytics (and, if configured, Google Tag Manager and Google Ads conversion tags) only after you accept all cookies. You can choose necessary cookies only. Details are in our <a href="/cookie-policy">Cookie Policy</a>. For more information, please visit <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.

#### Google Cloud Storage
We use Google Cloud Storage to securely store encrypted backups of server backups, ensuring both safe storage and rapid recovery in case of system failure. 

<br/>

### Changes to This Privacy Policy
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date at the top of this policy.



### Contact Us
Your data can be deleted by sending a request [via WhatsApp](https://wa.me/31639202608). 

If you have any other questions about this Privacy Policy or the Terms and Conditions, please feel free to [contact us](https://wa.me/31639202608).
`;
